import { connect } from 'react-redux';
import SubscriptionComponent from '../views/subscription/subscriptionComponent';
import { incrementCount } from '../../redux/actions/authentication';

const mapStateToProps = (state) => ({
    count : state.authentication.count
});

const mapDispatchToProps = (dispatch) => ({
    incrementCount : () => dispatch(incrementCount())
});

const Subscription = connect(
  mapStateToProps,
  mapDispatchToProps
)(SubscriptionComponent);

export default Subscription;